import { InlineIcon } from "@iconify/react";

interface LoadingOverlayProps {
  isDarkMode: boolean;
  title?: string;
  description?: string;
}

export function LoadingOverlay({
  isDarkMode,
  title = "Submitting quotation request...",
  description = "Please wait while your quotation request is being submitted.",
}: LoadingOverlayProps) {
  return (
    <div
      className={[
        "absolute",
        "inset-0",
        "rounded",
        "grid",
        "place-content-center",
        "z-[9999]",
        isDarkMode ? "bg-gray-800/90 backdrop-blur-sm" : "bg-white/90 backdrop-blur-sm",
      ].join(" ")}
    >
      <div className="grid grid-cols-1 gap-4 items-center justify-items-center p-8">
        <InlineIcon
          icon="svg-spinners:ring-resize"
          className={["text-5xl", isDarkMode ? "text-gray-300" : "text-gray-700"].join(" ")}
        />
        <p
          className={[
            "text-lg",
            "font-medium",
            isDarkMode ? "text-gray-300" : "text-gray-700",
          ].join(" ")}
        >
          {title}
        </p>
        <p className={["text-sm", isDarkMode ? "text-gray-400" : "text-gray-500"].join(" ")}>
          {description}
        </p>
      </div>
    </div>
  );
}
